import { makeStyles } from '@mui/styles';

const ViewRangosStyles = makeStyles(() => ({
	root: {
		backgroundColor: 'rgba(255, 255, 255, 0.2)',
		alignItems: 'center',
		display: 'flex',
		height: '100vh',
		justifyContent: 'center',
		left: 0,
		position: 'fixed',
		top: 0,
		width: '100%',
		zIndex: 1301,
	},
	rootBg: {
		backdropFilter: 'blur(3px)',
		background: 'rgba(0, 0, 0, 0.5)',
		height: '100%',
		left: 0,
		position: 'absolute',
		top: 0,
		width: '100%',
		zIndex: 1,
	},
	container: {
		backgroundColor: '#FFFFFF',
		zIndex: 1300,
		borderRadius: 20,
		width: 742,
		height: 702,
		position: 'fixed',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		maxHeight: '91%',
		overflow: 'hidden',
	},
	headerContainer: {
		alignItems: 'center',
		borderBottom: '1px solid rgba(112, 112, 112, 0.16)',
		display: 'flex',
		flexFlow: 'row wrap',
		justifyContent: 'space-between',
		padding: '13px 25px 6px 40px',
	},
	bodyContainer: {
		zIndex: 1400,
		maxHeight: 620,
		paddingBottom: '30px',
		overflowY: 'auto',
		scrollbarColor: '#1063AC #E9E9E9',
		scrollbarWidth: 'thin',
		'&::-webkit-scrollbar': {
			width: 6,
		},
		'&::-webkit-scrollbar-track': {
			backgroundColor: '#E9E9E9',
			borderRadius: 7,
		},
		'&::-webkit-scrollbar-thumb': {
			backgroundColor: '#c7c7c7',
			borderRadius: 7,
		},
	},
	footerContainer: {
		display: 'flex',
		justifyContent: 'flex-end',
		//padding: Theme.spacing(2),
	},

	tituloTabla: {
		color: '#1063AC !important',
		fontFamily: 'Montserrat !important',
		fontSize: '16px !important',
		fontWeight: 'bold !important',
		width: 650,
		borderBottom: '0 !important',
	},
	thead: {
		background: 'white',
		width: '100%',
	},
	icon: {
		color: '#0D66B6',
		fontSize: '20px !important',
		cursor: 'pointer',
	},
	textField: {
		width: 80,
	},
}));

export default ViewRangosStyles;
